// Add Vyper language support to Prism.js
// Save this file to src/utils/prism-vyper.js

// This is a simple definition for the Vyper language which is similar to Python
// but with some solidity-like features for smart contracts

import Prism from 'prismjs';

Prism.languages.vyper = {
  'comment': {
    pattern: /(^|[^\\])#.*/,
    lookbehind: true
  },
  'string-interpolation': {
    pattern: /(?:f|rf|fr)(?:("""[\s\S]*?""")|('''[\s\S]*?''')|(["'])(?:\\.|(?!\3)[^\\\r\n])*\3)/i,
    greedy: true,
    inside: {
      'interpolation': {
        pattern: /((?:^|[^{])(?:{{)*){(?!{)(?:[^{}]|{(?!{)(?:[^{}]|{(?!{)(?:[^{}])+})+})+}/,
        lookbehind: true,
        inside: {
          'format-spec': {
            pattern: /(:)[^:(){}]+(?=}$)/,
            lookbehind: true
          },
          'conversion-option': {
            pattern: /![sra](?=[:}]$)/,
            alias: 'punctuation'
          },
          rest: null
        }
      },
      'string': /[\s\S]+/
    }
  },
  'string': {
    pattern: /(?:("""[\s\S]*?""")|('''[\s\S]*?''')|(["'])(?:\\.|(?!\3)[^\\\r\n])*\3)/,
    greedy: true
  },
  'function': {
    pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
    lookbehind: true
  },
  'keyword': /\b(?:as|assert|break|class|constant|continue|contract|def|del|elif|else|except|external|finally|for|from|global|if|import|in|interface|is|lambda|nonpayable|pass|payable|raise|return|self|struct|try|while|with|yield)\b/,
  'boolean': /\b(?:True|False|None)\b/,
  'number': /(?:\b(?=\d)|\B(?=\.))(?:0[bo])?(?:(?:\d|0x[\da-f])[\da-f]*(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?j?\b/i,
  'operator': /[-+%=]=?|!=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
  'punctuation': /[{}[\];(),.:]/
};

// Link the interpolation pattern to the vyper pattern
Prism.languages.vyper['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.vyper;

// Add vyper support for HTML blocks
Prism.languages.markup = {
  ...Prism.languages.markup,
  'vyper': Prism.languages.vyper
};

export default Prism;